import { DetailsScreeningResultDto } from 'api/WorldCheck/DetailsScreeningResultDto'
import { ResolveFormSubmitValues } from 'api/WorldCheck/Types/ResolveFormSubmitValues'
import { ScreenClient } from 'api/WorldCheck/Types/ScreenClient'
import { ScreeningResultsDto } from 'api/WorldCheck/Types/ScreeningResultsDto'
import { WorldCheckTypesDto } from 'api/WorldCheck/Types/WorldCheckTypesDto'

import { PageData } from '../../api/Pagination/Types'
import { ApiClient } from './ApiClient'
import { PageQuery, preparePageQueryParams } from './index'

export class WorldCheckApiClient {
  constructor(private apiClient: ApiClient) {}
  sendClientForWorldCheckVerification: (data: ScreenClient) => Promise<ScreeningResultsDto> = (
    data
  ) => {
    return this.apiClient.post('worldcheck/screenings', data)
  }
  getWorldCheckScreeningById: (id: string) => Promise<ScreeningResultsDto> = (id) => {
    return this.apiClient.get(`worldcheck/screenings/${id}`)
  }
  getWorldCheckRecords: (
    clientId: string,
    typeId: number,
    query?: PageQuery
  ) => Promise<PageData<ScreeningResultsDto[]>> = (clientId, typeId, query) => {
    return this.apiClient.get(
      `worldcheck/screenings?Search=(ClientId == ${clientId}) AND (TypeId == ${typeId})&${preparePageQueryParams(
        query
      )}`
    )
  }
  getWorldCheckDetailsDataByReferenceId: (
    referenceId: string
  ) => Promise<DetailsScreeningResultDto> = (referenceId) => {
    return this.apiClient.get(`worldcheck/profiles/${referenceId}`)
  }
  resolveWorldCheckRecords: (
    screeningId: string,
    data: ResolveFormSubmitValues
  ) => Promise<DetailsScreeningResultDto> = (screeningId, data) => {
    return this.apiClient.put(`worldcheck/screenings/${screeningId}/resolve`, data)
  }
  archiveWorldCheckRecords: (screeningId: string) => Promise<DetailsScreeningResultDto> = (
    screeningId
  ) => {
    return this.apiClient.put(`worldcheck/screenings/${screeningId}/archive`, { id: screeningId })
  }
  getWorldCheckTypes: () => Promise<WorldCheckTypesDto> = () => {
    return this.apiClient.get(`worldcheck/types`)
  }
}
